import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CasesListComponent } from './cases-list/cases-list.component';
import { CasesDetailComponent } from './cases-detail/cases-detail.component';
import { PlanComponent } from './plan/plan.component';

const routes: Routes = [
    {
        path: 'cases',
        children: [
            { path: '', component: CasesListComponent }
        ]
    },
    {
        path: 'cases/planification',
        children: [
            { path: '', component: PlanComponent }
        ]
    },
    {
        path: 'cases/:id',
        children: [
            { 
                path: '', 
                component: CasesDetailComponent,
                canDeactivate: [(component:CasesDetailComponent)=> component.canDeactivate()]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    
    exports: [RouterModule]
})
export class CasesRoutingModule { }
